import React, { useEffect, useState } from "react"
import { FormCheck } from "react-bootstrap"
import { Dropdown } from "react-bootstrap"
import axios from "axios"
import { localserver } from "../../../api/common"
import { showToast } from "../../Shared/ToastMessage"
import { FaSave } from "react-icons/fa";
import { useUser } from '../../AdminUsers/UserContext';

const Support = ({ rolesAndPermissionData, formState, setFormState, handleFormChange }) => {

  const { checkPermission } = useUser();
  const [permissions, setPermissions] = useState({})

  useEffect(() => {
    if (rolesAndPermissionData && rolesAndPermissionData.length > 0) {
      const initialPermissions = {}
      rolesAndPermissionData.forEach((module) => {
        const hasAnyPermission =
          module.permission_view === 1 ||
          module.permission_create === 1 ||
          module.permission_update === 1 ||
          Number.parseInt(module.permission_delete) === 1

        initialPermissions[module.id] = {
          enabled: hasAnyPermission,
          view: module.permission_view === 1,
          create: module.permission_create === 1,
          edit: module.permission_update === 1,
          delete: Number.parseInt(module.permission_delete) === 1,
          permission_id: module.permission_id
        }
      })
      setPermissions(initialPermissions)
    }
  }, [rolesAndPermissionData])

  const handleModuleToggle = (moduleId, checked) => {
    setPermissions((prev) => ({
      ...prev,
      [moduleId]: {
        ...prev[moduleId],
        enabled: checked,
      },
    }))
  }

  const handlePermissionChange = (moduleId, permissionType, checked) => {
    setPermissions((prev) => ({
      ...prev,
      [moduleId]: {
        ...prev[moduleId],
        [permissionType]: checked,
      },
    }))
  }

  const handleSavePermissions = async () => {
    try {
      const hasPermission = await checkPermission("Roles & Permissions", "update");
      if (!hasPermission) return;
      const permissionsArray = Object.entries(permissions)
        .filter(([moduleId, perms]) => perms.enabled)
        .map(([moduleId, perms]) => ({
          permission_id: perms.permission_id,
          module: Number.parseInt(moduleId),
          permission_view: perms.view ? 1 : 0,
          permission_create: perms.create ? 1 : 0,
          permission_update: perms.edit ? 1 : 0,
          permission_delete: perms.delete ? 1 : 0,
        }))

      const payload = {
        role: 4, // Admin role ID
        permissions: permissionsArray,
      }
      console.log("payload: ", payload);
      const response = await axios.post(`${localserver}/set_user_permissions`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })

      if (response.data.success) {
        showToast("Permissions saved successfully", "success")
      } else {
        showToast("Failed to save permissions", "error")
      }
    } catch (error) {
      console.error("Error saving permissions:", error)
      showToast("An error occurred while saving permissions", "error")
    }
  }

  return (
    <div>
      {/* Organization Logo Section */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: "24px",
          marginBottom: "24px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          border: "1px solid #f1f5f9",
        }}
      >
        <div className="container-fluid">
          <div className="row clearfix">
            <div className="col-lg-12">
              <div className="body">
                <div className="row">
                  <div className="col-md-12 mb-4">
                    {rolesAndPermissionData &&
                      rolesAndPermissionData.map((module) => (
                        <div className="col-md-12 pt-3" key={module.id}>
                          <div className="roles_edid_flex">
                            <div className="d-flex">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  className="lv-btn small-switch"
                                  checked={permissions[module.id]?.enabled || false}
                                  onChange={(e) => handleModuleToggle(module.id, e.target.checked)}
                                />
                                <span className="slider round"></span>
                              </label>
                              <p className="ml-2 mb-0">
                                <b>{module.module_name}</b>
                              </p>
                            </div>
                            <Dropdown className="add_edit_dropdown">
                              <Dropdown.Toggle
                                variant=""
                                id={`dropdown-${module.id}`}
                                disabled={!permissions[module.id]?.enabled}
                              >
                                <strong>Permissions</strong>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <p className="dropdown-item m-0">
                                  <label>
                                    <FormCheck
                                      type="checkbox"
                                      id={`checkbox-view-${module.id}`}
                                      checked={permissions[module.id]?.view || false}
                                      onChange={(e) => handlePermissionChange(module.id, "view", e.target.checked)}
                                      label=" "
                                    />
                                    <span>View</span>
                                  </label>
                                </p>
                                <p className="dropdown-item m-0">
                                  <label>
                                    <FormCheck
                                      type="checkbox"
                                      id={`checkbox-create-${module.id}`}
                                      checked={permissions[module.id]?.create || false}
                                      onChange={(e) => handlePermissionChange(module.id, "create", e.target.checked)}
                                      label=" "
                                    />
                                    <span>Create</span>
                                  </label>
                                </p>
                                <p className="dropdown-item m-0">
                                  <label>
                                    <FormCheck
                                      type="checkbox"
                                      id={`checkbox-edit-${module.id}`}
                                      checked={permissions[module.id]?.edit || false}
                                      onChange={(e) => handlePermissionChange(module.id, "edit", e.target.checked)}
                                      label=" "
                                    />
                                    <span>Edit</span>
                                  </label>
                                </p>
                                <p className="dropdown-item m-0">
                                  <label>
                                    <FormCheck
                                      type="checkbox"
                                      id={`checkbox-delete-${module.id}`}
                                      checked={permissions[module.id]?.delete || false}
                                      onChange={(e) => handlePermissionChange(module.id, "delete", e.target.checked)}
                                      label=" "
                                    />
                                    <span>Delete</span>
                                  </label>
                                </p>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                      ))}

                    <div className="col-md-12 pt-4">
                      <div style={styles.saveButtonContainer}>
                        <button
                          style={styles.saveButton}
                          onClick={handleSavePermissions}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#0f3a5f"
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#184778"
                          }}
                        >
                         <FaSave size={14} />
                          Save Permissions
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const styles = {
  saveButtonContainer: {
    display: "flex",
    justifyContent: "flex-start",
    paddingTop: "24px",
    borderTop: "1px solid #e5e7eb",
  },
  saveButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    backgroundColor: "#184778",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  },
  saveButtonIcon: {
    fontSize: "14px",
  },
}

export default Support
